export const SECTIONS = {
  addItem: 'addItem',
  configureItem: 'configureItem',
  floorConfigrator: 'floorConfigurator',
};
